<rask-textarea class="w-100 p-0" [label]="label"
    (ngModelChange)="onChange()"
    [(ngModel)]="kontrakt.anteckningSkogsvard"
    [maxlength]="500"
    [disabled]="readonly">
</rask-textarea>
